module.exports = __webpack_public_path__ + "static/media/spanish.9238248d.svg";